export default __webpack_public_path__ + "static/home-cover-alt-134af14b3eb2e6ed3fec6853ec8cdd3c.jpg";